export const STATIC_CHANNELS = new Map([
  [
    1187,
    {
      id: "1187",
      name: "4ever Cinema",
      categories: ["324", "647"],
      male: "50%",
      female: "50%",
      age18_24: "5%",
      age25_34: "24%",
      age35_44: "29%",
      age45_54: "18%",
      age55_64: "15%",
      age65plus: "9%",
      viewersPerDevice: 1.58,
    },
  ],
  [
    1218,
    {
      id: "1218",
      name: "4ever Theater",
      categories: ["324"],
      male: "52%",
      female: "48%",
      age18_24: "4%",
      age25_34: "21%",
      age35_44: "36%",
      age45_54: "15%",
      age55_64: "14%",
      age65plus: "10%",
      viewersPerDevice: 1.58,
    },
  ],
  [
    1219,
    {
      id: "1219",
      name: "4ever Drama",
      categories: ["324", "647"],
      male: "48%",
      female: "52%",
      age18_24: "5%",
      age25_34: "24%",
      age35_44: "28%",
      age45_54: "20%",
      age55_64: "14%",
      age65plus: "8%",
      viewersPerDevice: 1.58,
    },
  ],
  [
    366,
    {
      id: "366",
      name: "4ever music",
      categories: ["650"],
      male: "50%",
      female: "50%",
      age18_24: "4%",
      age25_34: "18%",
      age35_44: "25%",
      age45_54: "31%",
      age55_64: "13%",
      age65plus: "8%",
      viewersPerDevice: 1.26,
    },
  ],
  [
    48,
    {
      id: "48",
      name: "EU Music",
      categories: ["650"],
      male: "39%",
      female: "61%",
      age18_24: "12%",
      age25_34: "19%",
      age35_44: "22%",
      age45_54: "23%",
      age55_64: "17%",
      age65plus: "7%",
      viewersPerDevice: 1.26,
    },
  ],
  [
    1188,
    {
      id: "1188",
      name: "Black",
      categories: ["650"],
      male: "70%",
      female: "30%",
      age18_24: "24%",
      age25_34: "12%",
      age35_44: "24%",
      age45_54: "8%",
      age55_64: "15%",
      age65plus: "17%",
      viewersPerDevice: 1.25,
    },
  ],
  [
    1223,
    {
      id: "1223",
      name: "Viva Latino",
      categories: ["650"],
      male: "37%",
      female: "63%",
      age18_24: "6%",
      age25_34: "27%",
      age35_44: "31%",
      age45_54: "14%",
      age55_64: "15%",
      age65plus: "7%",
      viewersPerDevice: 1.26,
    },
  ],
  [
    1210,
    {
      id: "1210",
      name: "UAMusic",
      categories: ["650"],
      male: "48%",
      female: "52%",
      age18_24: "7%",
      age25_34: "29%",
      age35_44: "35%",
      age45_54: "14%",
      age55_64: "6%",
      age65plus: "9%",
      viewersPerDevice: 1.24,
    },
  ],
  [
    280,
    {
      id: "280",
      name: "NIKI Junior",
      categories: ["645", "641"],
      male: "43%",
      female: "57%",
      age18_24: "0%",
      age25_34: "40%",
      age35_44: "46%",
      age45_54: "10%",
      age55_64: "2%",
      age65plus: "1%",
      viewersPerDevice: 2.09,
    },
  ],
  [
    283,
    {
      id: "283",
      name: "NIKI Kids",
      categories: ["645", "641"],
      male: "32%",
      female: "68%",
      age18_24: "0%",
      age25_34: "29%",
      age35_44: "51%",
      age45_54: "10%",
      age55_64: "4%",
      age65plus: "5%",
      viewersPerDevice: 2.04,
    },
  ],
  [
    267,
    {
      id: "267",
      name: "Bolt",
      categories: ["640", "647"],
      male: "55%",
      female: "45%",
      age18_24: "4%",
      age25_34: "27%",
      age35_44: "31%",
      age45_54: "17%",
      age55_64: "11%",
      age65plus: "10%",
      viewersPerDevice: 1.64,
    },
  ],
  [
    1255,
    {
      id: "1255",
      name: "ProKino",
      categories: ["324", "647"],
      male: "50%",
      female: "50%",
      age18_24: "5%",
      age25_34: "24%",
      age35_44: "29%",
      age45_54: "18%",
      age55_64: "15%",
      age65plus: "9%",
      viewersPerDevice: 1.58,
    },
  ],
  [
    102,
    {
      id: "102",
      name: "FilmUADrama",
      categories: ["640", "647"],
      male: "40%",
      female: "60%",
      age18_24: "6%",
      age25_34: "25%",
      age35_44: "30%",
      age45_54: "17%",
      age55_64: "15%",
      age65plus: "7%",
      viewersPerDevice: 1.58,
    },
  ],
  [
    91,
    {
      id: "91",
      name: "Світло",
      categories: ["324", "640", "648"],
      male: "50%",
      female: "50%",
      age18_24: "5%",
      age25_34: "24%",
      age35_44: "29%",
      age45_54: "18%",
      age55_64: "15%",
      age65plus: "9%",
      viewersPerDevice: 1.74,
    },
  ],
  [
    1140,
    {
      id: "1140",
      name: "Utravel",
      categories: ["159", "TIFQA5"],
      male: "42%",
      female: "58%",
      age18_24: "5%",
      age25_34: "24%",
      age35_44: "30%",
      age45_54: "16%",
      age55_64: "16%",
      age65plus: "8%",
      viewersPerDevice: 1.34,
    },
  ],
  [
    353,
    {
      id: "353",
      name: "36,6 HD",
      categories: ["216"],
      male: "35%",
      female: "65%",
      age18_24: "4%",
      age25_34: "18%",
      age35_44: "26%",
      age45_54: "24%",
      age55_64: "18%",
      age65plus: "10%",
      viewersPerDevice: 1.24,
    },
  ],
  [
    410,
    {
      id: "410",
      name: "Кус КУС",
      categories: ["216"],
      male: "38%",
      female: "62%",
      age18_24: "6%",
      age25_34: "28%",
      age35_44: "32%",
      age45_54: "16%",
      age55_64: "12%",
      age65plus: "6%",
      viewersPerDevice: 1.36,
    },
  ],
  [
    83,
    {
      id: "83",
      name: "Дача",
      categories: ["159", "TIFQA5"],
      male: "45%",
      female: "55%",
      age18_24: "4%",
      age25_34: "20%",
      age35_44: "30%",
      age45_54: "22%",
      age55_64: "16%",
      age65plus: "8%",
      viewersPerDevice: 1.45,
    },
  ],
  [
    246,
    {
      id: "246",
      name: "Star Cinema",
      categories: ["324", "647"],
      male: "51%",
      female: "49%",
      age18_24: "6%",
      age25_34: "23%",
      age35_44: "28%",
      age45_54: "18%",
      age55_64: "16%",
      age65plus: "9%",
      viewersPerDevice: 1.62,
    },
  ],
  [
    13,
    {
      id: "13",
      name: "XSPORT",
      categories: ["325"],
      male: "70%",
      female: "30%",
      age18_24: "9%",
      age25_34: "25%",
      age35_44: "31%",
      age45_54: "18%",
      age55_64: "12%",
      age65plus: "5%",
      viewersPerDevice: 1.64,
    },
  ],
  [
    1128,
    {
      id: "1128",
      name: "Xsport+",
      categories: ["325"],
      male: "70%",
      female: "30%",
      age18_24: "9%",
      age25_34: "25%",
      age35_44: "31%",
      age45_54: "18%",
      age55_64: "12%",
      age65plus: "5%",
      viewersPerDevice: 1.66,
    },
  ],
  [
    49,
    {
      id: "49",
      name: "Еспресо TV",
      categories: ["648"],
      male: "55%",
      female: "45%",
      age18_24: "6%",
      age25_34: "20%",
      age35_44: "26%",
      age45_54: "22%",
      age55_64: "16%",
      age65plus: "10%",
      viewersPerDevice: 1.18,
    },
  ],
  [
    40,
    {
      id: "40",
      name: "Київ",
      categories: ["648"],
      male: "46%",
      female: "54%",
      age18_24: "5%",
      age25_34: "22%",
      age35_44: "29%",
      age45_54: "21%",
      age55_64: "15%",
      age65plus: "8%",
      viewersPerDevice: 1.17,
    },
  ],
  [
    1226,
    {
      id: "1226",
      name: "NOW Series",
      categories: ["640", "647"],
      male: "44%",
      female: "56%",
      age18_24: "6%",
      age25_34: "28%",
      age35_44: "31%",
      age45_54: "17%",
      age55_64: "12%",
      age65plus: "6%",
      viewersPerDevice: 1.62,
    },
  ],
  [
    327,
    {
      id: "327",
      name: "Дорама",
      categories: ["324", "647"],
      male: "30%",
      female: "70%",
      age18_24: "7%",
      age25_34: "34%",
      age35_44: "32%",
      age45_54: "15%",
      age55_64: "8%",
      age65plus: "4%",
      viewersPerDevice: 1.64,
    },
  ],
  [
    417,
    {
      id: "417",
      name: "Рибалка ТВ",
      categories: ["159"],
      male: "80%",
      female: "20%",
      age18_24: "3%",
      age25_34: "15%",
      age35_44: "25%",
      age45_54: "25%",
      age55_64: "20%",
      age65plus: "12%",
      viewersPerDevice: 1.17,
    },
  ],
  [
    1228,
    {
      id: "1228",
      name: "Kinowood",
      categories: ["324"],
      male: "50%",
      female: "50%",
      age18_24: "6%",
      age25_34: "24%",
      age35_44: "29%",
      age45_54: "18%",
      age55_64: "15%",
      age65plus: "8%",
      viewersPerDevice: 1.57,
    },
  ],
  [
    1254,
    {
      id: "1254",
      name: "Zoosweet",
      categories: ["332", "VKIV56"],
      male: "40%",
      female: "60%",
      age18_24: "5%",
      age25_34: "22%",
      age35_44: "30%",
      age45_54: "20%",
      age55_64: "15%",
      age65plus: "8%",
      viewersPerDevice: 1.33,
    },
  ],
  [
    1127,
    {
      id: "1127",
      name: "Кіноказка",
      categories: ["645", "641"],
      male: "35%",
      female: "65%",
      age18_24: "0%",
      age25_34: "32%",
      age35_44: "48%",
      age45_54: "12%",
      age55_64: "5%",
      age65plus: "3%",
      viewersPerDevice: 1.98,
    },
  ],
  [
    1217,
    {
      id: "1217",
      name: "Kinoliving",
      categories: ["640", "647"],
      male: "48%",
      female: "52%",
      age18_24: "5%",
      age25_34: "24%",
      age35_44: "30%",
      age45_54: "18%",
      age55_64: "14%",
      age65plus: "9%",
      viewersPerDevice: 1.62,
    },
  ],
  [
    1212,
    {
      id: "1212",
      name: "Контінент Е",
      categories: ["640"],
      male: "50%",
      female: "50%",
      age18_24: "6%",
      age25_34: "23%",
      age35_44: "28%",
      age45_54: "19%",
      age55_64: "15%",
      age65plus: "9%",
      viewersPerDevice: 1.8,
    },
  ],
  [
    328,
    {
      id: "328",
      name: "НАШЕ УЛЮБЛЕНЕ КІНО",
      categories: ["324"],
      male: "45%",
      female: "55%",
      age18_24: "4%",
      age25_34: "20%",
      age35_44: "30%",
      age45_54: "22%",
      age55_64: "16%",
      age65plus: "8%",
      viewersPerDevice: 1.57,
    },
  ],
  [
    350,
    {
      id: "350",
      name: "Travel&Food",
      categories: ["640", "159", "216", "TIFQA5"],
      male: "37%",
      female: "63%",
      age18_24: "6%",
      age25_34: "29%",
      age35_44: "32%",
      age45_54: "17%",
      age55_64: "11%",
      age65plus: "5%",
      viewersPerDevice: 1.36,
    },
  ],
  [
    1252,
    {
      id: "1252",
      name: "Kinosweet",
      categories: ["324"],
      male: "46%",
      female: "54%",
      age18_24: "5%",
      age25_34: "24%",
      age35_44: "30%",
      age45_54: "18%",
      age55_64: "15%",
      age65plus: "8%",
      viewersPerDevice: 1.58,
    },
  ],
  [
    1221,
    {
      id: "1221",
      name: "One Planet",
      categories: ["332", "153, 160"],
      male: "45%",
      female: "55%",
      age18_24: "5%",
      age25_34: "22%",
      age35_44: "28%",
      age45_54: "20%",
      age55_64: "16%",
      age65plus: "9%",
      viewersPerDevice: 1.35,
    },
  ],
  [
    1124,
    {
      id: "1124",
      name: "Gagsnetwork",
      categories: ["646"],
      male: "52%",
      female: "48%",
      age18_24: "15%",
      age25_34: "35%",
      age35_44: "25%",
      age45_54: "15%",
      age55_64: "7%",
      age65plus: "3%",
      viewersPerDevice: 1.66,
    },
  ],
  [
    1276,
    {
      id: "1276",
      name: "Речдок+",
      categories: ["332", "380"],
      male: "54%",
      female: "46%",
      age18_24: "4%",
      age25_34: "18%",
      age35_44: "26%",
      age45_54: "24%",
      age55_64: "18%",
      age65plus: "10%",
      viewersPerDevice: 1.25,
    },
  ],
  [
    1275,
    {
      id: "1275",
      name: "Орел & Решка+",
      categories: ["640", "159", "TIFQA5"],
      male: "40%",
      female: "60%",
      age18_24: "8%",
      age25_34: "32%",
      age35_44: "30%",
      age45_54: "16%",
      age55_64: "10%",
      age65plus: "4%",
      viewersPerDevice: 1.35,
    },
  ],
  [
    1288,
    {
      id: "1288",
      name: "Готуємо разом+",
      categories: ["216"],
      male: "35%",
      female: "65%",
      age18_24: "6%",
      age25_34: "30%",
      age35_44: "34%",
      age45_54: "16%",
      age55_64: "10%",
      age65plus: "4%",
      viewersPerDevice: 1.33,
    },
  ],
  [
    1529,
    {
      id: "1529",
      name: "Орел & Решка: Морський сезон +",
      categories: ["640", "159", "TIFQA5"],
      male: "42%",
      female: "58%",
      age18_24: "7%",
      age25_34: "30%",
      age35_44: "31%",
      age45_54: "17%",
      age55_64: "11%",
      age65plus: "4%",
      viewersPerDevice: 1.35,
    },
  ],
  [
    1290,
    {
      id: "1290",
      name: "Стосується кожного+",
      categories: ["186"],
      male: "45%",
      female: "55%",
      age18_24: "4%",
      age25_34: "18%",
      age35_44: "26%",
      age45_54: "24%",
      age55_64: "18%",
      age65plus: "10%",
      viewersPerDevice: 1.76,
    },
  ],
  [
    1277,
    {
      id: "1277",
      name: "Кіно та серіали+",
      categories: ["324", "640"],
      male: "46%",
      female: "54%",
      age18_24: "5%",
      age25_34: "24%",
      age35_44: "30%",
      age45_54: "18%",
      age55_64: "15%",
      age65plus: "8%",
      viewersPerDevice: 1.59,
    },
  ],
  [
    1294,
    {
      id: "1294",
      name: "Cinema Kinohit",
      categories: ["324"],
      male: "51%",
      female: "49%",
      age18_24: "6%",
      age25_34: "23%",
      age35_44: "29%",
      age45_54: "18%",
      age55_64: "15%",
      age65plus: "9%",
      viewersPerDevice: 1.61,
    },
  ],
  [
    1248,
    {
      id: "1248",
      name: "Cinema Megahit",
      categories: ["324"],
      male: "52%",
      female: "48%",
      age18_24: "7%",
      age25_34: "24%",
      age35_44: "28%",
      age45_54: "18%",
      age55_64: "14%",
      age65plus: "9%",
      viewersPerDevice: 1.61,
    },
  ],
  [
    1247,
    {
      id: "1247",
      name: "Cinema Comedy",
      categories: ["324", "646"],
      male: "48%",
      female: "52%",
      age18_24: "12%",
      age25_34: "34%",
      age35_44: "26%",
      age45_54: "16%",
      age55_64: "8%",
      age65plus: "4%",
      viewersPerDevice: 1.67,
    },
  ],
  [
    1245,
    {
      id: "1245",
      name: "Cinema Fantasy",
      categories: ["324", "335"],
      male: "53%",
      female: "47%",
      age18_24: "8%",
      age25_34: "26%",
      age35_44: "30%",
      age45_54: "18%",
      age55_64: "12%",
      age65plus: "6%",
      viewersPerDevice: 1.6,
    },
  ],
  [
    1246,
    {
      id: "1246",
      name: "Cinema Action",
      categories: ["324"],
      male: "65%",
      female: "35%",
      age18_24: "7%",
      age25_34: "24%",
      age35_44: "32%",
      age45_54: "20%",
      age55_64: "12%",
      age65plus: "5%",
      viewersPerDevice: 1.6,
    },
  ],
  [
    1260,
    {
      id: "1260",
      name: "Cinema Family",
      categories: ["645", "192"],
      male: "40%",
      female: "60%",
      age18_24: "2%",
      age25_34: "28%",
      age35_44: "42%",
      age45_54: "16%",
      age55_64: "8%",
      age65plus: "4%",
      viewersPerDevice: 1.88,
    },
  ],
  [
    1296,
    {
      id: "1296",
      name: "Cinema Legend",
      categories: ["324"],
      male: "50%",
      female: "50%",
      age18_24: "4%",
      age25_34: "20%",
      age35_44: "30%",
      age45_54: "22%",
      age55_64: "16%",
      age65plus: "8%",
      viewersPerDevice: 1.6,
    },
  ],
  [
    1295,
    {
      id: "1295",
      name: "Cinema Prime",
      categories: ["324"],
      male: "51%",
      female: "49%",
      age18_24: "6%",
      age25_34: "24%",
      age35_44: "29%",
      age45_54: "18%",
      age55_64: "14%",
      age65plus: "9%",
      viewersPerDevice: 1.6,
    },
  ],
  [
    1647,
    {
      id: "1647",
      name: "Cinema Horrors",
      categories: ["324", "336"],
      male: "70%",
      female: "30%",
      age18_24: "10%",
      age25_34: "28%",
      age35_44: "30%",
      age45_54: "18%",
      age55_64: "9%",
      age65plus: "5%",
      viewersPerDevice: 1.43,
    },
  ],
  [
    1637,
    {
      id: "1637",
      name: "Viasat Explore Pro",
      categories: ["159", "332", "VKIV56"],
      male: "65%",
      female: "35%",
      age18_24: "6%",
      age25_34: "22%",
      age35_44: "30%",
      age45_54: "20%",
      age55_64: "14%",
      age65plus: "8%",
      viewersPerDevice: 1.35,
    },
  ],
  [
    1639,
    {
      id: "1639",
      name: "Viasat Nature Pro",
      categories: ["332", "153, 160"],
      male: "45%",
      female: "55%",
      age18_24: "5%",
      age25_34: "20%",
      age35_44: "28%",
      age45_54: "22%",
      age55_64: "16%",
      age65plus: "9%",
      viewersPerDevice: 1.35,
    },
  ],
  [
    1638,
    {
      id: "1638",
      name: "Viasat History Pro",
      categories: ["332", "EZWB7V"],
      male: "50%",
      female: "50%",
      age18_24: "4%",
      age25_34: "18%",
      age35_44: "26%",
      age45_54: "24%",
      age55_64: "18%",
      age65plus: "10%",
      viewersPerDevice: 1.25,
    },
  ],
  [
    1519,
    {
      id: "1519",
      name: "Classic Movies&Cartoons",
      categories: ["645", "641"],
      male: "42%",
      female: "58%",
      age18_24: "2%",
      age25_34: "26%",
      age35_44: "38%",
      age45_54: "20%",
      age55_64: "10%",
      age65plus: "4%",
      viewersPerDevice: 2.07,
    },
  ],
  [
    1499,
    {
      id: "1499",
      name: "KinoErotica +",
      categories: [],
      male: "65%",
      female: "35%",
      age18_24: "6%",
      age25_34: "22%",
      age35_44: "28%",
      age45_54: "22%",
      age55_64: "14%",
      age65plus: "8%",
      viewersPerDevice: 1.0,
    },
  ],
  [
    29,
    {
      id: "29",
      name: "НТН OTT SA",
      categories: ["640", "324", "648"],
      male: "52%",
      female: "48%",
      age18_24: "6%",
      age25_34: "22%",
      age35_44: "28%",
      age45_54: "22%",
      age55_64: "15%",
      age65plus: "7%",
      viewersPerDevice: 1.52,
    },
  ],
  [
    42,
    {
      id: "42",
      name: "K1 OTT SA",
      categories: ["640"],
      male: "45%",
      female: "55%",
      age18_24: "6%",
      age25_34: "26%",
      age35_44: "32%",
      age45_54: "18%",
      age55_64: "12%",
      age65plus: "6%",
      viewersPerDevice: 1.7,
    },
  ],
  [
    50,
    {
      id: "50",
      name: "Ентер-фільм OTT SA",
      categories: ["324"],
      male: "48%",
      female: "52%",
      age18_24: "4%",
      age25_34: "20%",
      age35_44: "30%",
      age45_54: "22%",
      age55_64: "16%",
      age65plus: "8%",
      viewersPerDevice: 1.62,
    },
  ],
  [
    41,
    {
      id: "41",
      name: "K2 OTT SA",
      categories: ["640", "648"],
      male: "35%",
      female: "65%",
      age18_24: "6%",
      age25_34: "28%",
      age35_44: "34%",
      age45_54: "18%",
      age55_64: "10%",
      age65plus: "4%",
      viewersPerDevice: 1.82,
    },
  ],
  [
    27,
    {
      id: "27",
      name: "Піксель OTT SA",
      categories: ["645", "641"],
      male: "40%",
      female: "60%",
      age18_24: "1%",
      age25_34: "30%",
      age35_44: "45%",
      age45_54: "16%",
      age55_64: "6%",
      age65plus: "2%",
      viewersPerDevice: 2.1,
    },
  ],
  [
    1215,
    {
      id: "1215",
      name: "1+1 Україна OTT SA",
      categories: ["640", "648", "647"],
      male: "44%",
      female: "56%",
      age18_24: "7%",
      age25_34: "28%",
      age35_44: "31%",
      age45_54: "17%",
      age55_64: "12%",
      age65plus: "5%",
      viewersPerDevice: 1.9,
    },
  ],
  [
    22,
    {
      id: "22",
      name: "ТЕТ OTT SA",
      categories: ["640", "TIFQA5"],
      male: "38%",
      female: "62%",
      age18_24: "14%",
      age25_34: "36%",
      age35_44: "26%",
      age45_54: "14%",
      age55_64: "7%",
      age65plus: "3%",
      viewersPerDevice: 1.66,
    },
  ],
  [
    59,
    {
      id: "59",
      name: "2+2 OTT SA",
      categories: ["640", "647", "TIFQA5"],
      male: "65%",
      female: "35%",
      age18_24: "8%",
      age25_34: "26%",
      age35_44: "32%",
      age45_54: "20%",
      age55_64: "10%",
      age65plus: "4%",
      viewersPerDevice: 1.58,
    },
  ],
  [
    26,
    {
      id: "26",
      name: "ПЛЮСПЛЮС OTT SA",
      categories: ["645", "641"],
      male: "42%",
      female: "58%",
      age18_24: "1%",
      age25_34: "28%",
      age35_44: "44%",
      age45_54: "18%",
      age55_64: "6%",
      age65plus: "3%",
      viewersPerDevice: 2.08,
    },
  ],
  [
    12,
    {
      id: "12",
      name: "Бігуди OTT SA",
      categories: ["640", "TIFQA5", "192"],
      male: "30%",
      female: "70%",
      age18_24: "10%",
      age25_34: "34%",
      age35_44: "30%",
      age45_54: "16%",
      age55_64: "7%",
      age65plus: "3%",
      viewersPerDevice: 1.43,
    },
  ],
  [
    256,
    {
      id: "256",
      name: "Квартал OTT SA",
      categories: ["640", "646"],
      male: "48%",
      female: "52%",
      age18_24: "12%",
      age25_34: "34%",
      age35_44: "28%",
      age45_54: "16%",
      age55_64: "7%",
      age65plus: "3%",
      viewersPerDevice: 1.84,
    },
  ],
  [
    17,
    {
      id: "17",
      name: "Уніан ТБ OTT SA",
      categories: ["648"],
      male: "55%",
      female: "45%",
      age18_24: "6%",
      age25_34: "20%",
      age35_44: "26%",
      age45_54: "22%",
      age55_64: "16%",
      age65plus: "10%",
      viewersPerDevice: 1.17,
    },
  ],
  [
    7,
    {
      id: "7",
      name: "ZOOM OTT SA",
      categories: ["640", "647", "TIFQA5"],
      male: "50%",
      female: "50%",
      age18_24: "10%",
      age25_34: "32%",
      age35_44: "28%",
      age45_54: "16%",
      age55_64: "9%",
      age65plus: "5%",
      viewersPerDevice: 1.68,
    },
  ],
  [
    35,
    {
      id: "35",
      name: "Мега OTT SA",
      categories: ["332"],
      male: "52%",
      female: "48%",
      age18_24: "7%",
      age25_34: "24%",
      age35_44: "30%",
      age45_54: "18%",
      age55_64: "13%",
      age65plus: "8%",
      viewersPerDevice: 1.26,
    },
  ],
]);
